<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">Your Rating</p>
    </header>
    <section class="modal-card-body">
      <div class="rating-container has-text-primary"
        v-if="['on_dock', 'crew', 'diver'].indexOf(type) !== -1">
        <p>Your expertise rating:&nbsp;&nbsp;&nbsp;</p>
        <StarRating :star-size="20" :show-rating="false" v-model="expertise_score"/>
      </div>

      <div class="rating-container has-text-primary">
        <p>Your trust rating:&nbsp;&nbsp;&nbsp;</p>
        <StarRating :star-size="20" :show-rating="false" v-model="trust_score"/>
      </div>

      <div class="rating-container has-text-primary">
        <p>Your communication rating:&nbsp;&nbsp;&nbsp;</p>
        <StarRating :star-size="20" :show-rating="false" v-model="communication_score"/>
      </div>

      <div class="rating-container has-text-primary">
        <p>Your consistency rating:&nbsp;&nbsp;&nbsp;</p>
        <StarRating :star-size="20" :show-rating="false" v-model="consistency_score"/>
      </div>
    </section>
    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">Close</button>
      <button class="button is-primary" @click="$emit('rating_saved', {
        communication_score,
        trust_score,
        consistency_score,
        expertise_score
      })">Save</button>
    </footer>
  </div>
</template>

<script>
import StarRating from 'vue-star-rating';


export default {
  components: {
    StarRating,
  },

  data() {
    return {
      expertise_score: 1,
      trust_score: 1,
      communication_score: 1,
      consistency_score: 1,
    };
  },
  props: {
    rating: Object,
    type: String,
  },

  created() {
    if (this.rating) {
      this.expertise_score = this.rating.expertise_score;
      this.trust_score = this.rating.trust_score;
      this.communication_score = this.rating.communication_score;
      this.consistency_score = this.rating.consistency_score;
    }
  },
};
</script>

<style lang="scss" scoped>
.rating-container {
  max-width: 400px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>
